import script from "./DamagePosInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DamagePosInput.vue?vue&type=script&setup=true&lang=js"

import "./DamagePosInput.vue?vue&type=style&index=0&id=52e8731f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e8731f"]])

export default __exports__